import { CITY } from '@city'
import { useMemo, useSyncExternalStore } from 'react'
import { useSchema } from '../components/useSchema'
import { effectiveTheme } from '../state/effectiveTheme'
import { useMetroMapStore } from '../state/useMetroMapStore'
import { buildLineView, type LineView } from './buildLineView'

/**
 * The open line view, resolved for the map's effective theme — or `null`
 * when no line is selected, the schema is not in yet, or the line has no
 * diagram in this city.
 */
export function useLineView(): LineView | null {
  const store = useMetroMapStore()
  const schema = useSchema()
  const selectedLine = useSyncExternalStore(store.subscribe, () => store.getState().selectedLine)
  const theme = useSyncExternalStore(store.subscribe, () => effectiveTheme(store.getState()))
  return useMemo(
    () =>
      schema === null || selectedLine === null
        ? null
        : buildLineView(schema, selectedLine.lineId, theme, CITY),
    [schema, selectedLine, theme],
  )
}
